import { ApDialogRef } from './ApDialogConfig';
import { throwSyncError } from 'webcommon/shared/errors-ng1520';

export const NormalModalResult = 'ApActiveModalResult' as const;

export class ApActiveModal<T> {
  constructor(
    private _close: (value: T | PromiseLike<T>) => void,
    private _dismiss: (reason?: unknown) => void,
  ) {}

  private _dialogRef_InternalState?: ApDialogRef;
  get dialogRef(): ApDialogRef {
    return (
      this._dialogRef_InternalState ?? throwSyncError(new Error(`ApActiveModal.dialogRef not set, call setup() first.`))
    );
  }
  private beforeManualClose_InternalState?: () => void;
  private get beforeManualClose(): () => void {
    return (
      this.beforeManualClose_InternalState ??
      throwSyncError(new Error(`ApActiveModal.beforeManualClose not set, call setup() first.`))
    );
  }

  private closedOrDismissed_InternalState = false;
  private readyToHide_InternalState = false;

  setup(dialogRef: ApDialogRef, beforeManualClose: () => void) {
    this._dialogRef_InternalState = dialogRef;
    this.beforeManualClose_InternalState = beforeManualClose;
  }

  private onHide_InternalState: () => void = () => {
    this._dismiss(undefined);
  };

  // close the modal with a specific return value
  emitAndClose(result: T | PromiseLike<T>): void {
    this.onHide_InternalState = () => {
      this.closeModal();
      this._close(result);
    };
    this.closedOrDismissed_InternalState = true;
    this.tryHide();
  }

  // dismiss the modal for a specific reason (should normally be Error)
  dismiss(reason?: unknown): void {
    this.onHide_InternalState = () => {
      this.closeModal();
      this._dismiss(reason);
    };
    this.closedOrDismissed_InternalState = true;
    this.tryHide();
  }

  // call when closing of modal is already done elsewhere
  emitWithoutClose(result: T | PromiseLike<T>): void {
    this.onHide_InternalState = () => {
      this._close(result);
    };
    this.closedOrDismissed_InternalState = true;
    this.tryHide();
  }

  // call when closing of modal is already done elsewhere
  dismissWithoutClose(reason?: unknown): void {
    this.onHide_InternalState = () => {
      this._dismiss(reason);
    };
    this.closedOrDismissed_InternalState = true;
    this.tryHide();
  }

  markReadyToHide(): void {
    this.readyToHide_InternalState = true;
    this.tryHide();
  }

  // Don't hide the modal until it's ready to be hidden,
  // and there has been a call to close or dismiss it.
  private tryHide() {
    if (this.closedOrDismissed_InternalState && this.readyToHide_InternalState) {
      this.onHide_InternalState();
    }
  }

  private closeModal() {
    this.beforeManualClose();
    this.dialogRef.close(NormalModalResult);
  }
}
